import React, {memo, useCallback} from 'react';
import dayjs from "dayjs";
import toast from "react-hot-toast";
import {Button} from "antd";

const DateStepper = memo(({setRows, entity, isEnd = true}) => {
    const handlePlusOneBeginDay = useCallback(() => {
        setRows((prevState) => {
            const newState = {...prevState};
            newState.begin = dayjs.unix(newState.begin).add(1, 'day').hour(9).startOf('hour').unix();

            if (newState.end <= newState.begin) {
                newState.end = dayjs.unix(newState.begin).add(1, 'day').hour(8).endOf('hour').unix();
            }
            return new entity(newState);
        });
    },[setRows, entity]);

    const handleMinusOneBeginDay = useCallback(() => {
        setRows((prevState) => {
            const beginMinusAddDays = dayjs.unix(prevState.begin).subtract(1, 'day').hour(9).startOf('hour').unix();
            if (beginMinusAddDays < 0) {
                toast.error("시작일은 1970년 1월 1일 이후여야 합니다.");
                return new entity(prevState);
            }
            const newState = {...prevState};
            newState.begin = beginMinusAddDays;
            return new entity(newState);
        });
    }, [setRows, entity]);

    const handlePlusOneEndDay = useCallback(() => {
        setRows((prevState) => {
            const newState = {...prevState};
            newState.end  = dayjs.unix(newState.end).add(1, 'day').hour(8).endOf('hour').unix();
            return new entity(newState);
        });
    }, [setRows, entity]);

    const handleMinusOneEndDay = useCallback(() => {
        setRows((prevState) => {
            const endMinusAddDays = dayjs.unix(prevState.end).subtract(1, 'day').hour(8).endOf('hour').unix();
            if (endMinusAddDays < prevState.begin) {
                toast.error("종료일은 시작일보다 이전일 수 없습니다.");
                return new entity(prevState);
            }
            const newState = {...prevState};
            newState.end = endMinusAddDays;
            return new entity(newState);
        });
    }, [setRows, entity]);

    const handleToday = useCallback((type) => {
        setRows((prevState) => {
            const today = dayjs().startOf('day').unix();
            const newState = {...prevState};
            if (type === 'begin') {
                newState.begin = dayjs().hour(9).startOf('hour').unix();
            } else {
                newState.end = dayjs().hour(8).add(1, 'day').endOf('hour').unix();
            }
            return new entity(newState);
        });
    }, [setRows, entity]);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginTop: 5,
                marginBottom: 15
            }}
        >
            <Button
                variant={"outlined"}
                onClick={() => handleToday('begin')}
            >
                Today
            </Button>
            <Button
                variant="outlined"
                onClick={handlePlusOneBeginDay}
                style={{marginLeft: 5}}
            >
                시작일 +1
            </Button>
            <Button
                variant="outlined"
                onClick={handleMinusOneBeginDay}
                style={{marginLeft: 5}}
            >
                시작일 -1
            </Button>
            {isEnd && (
                <div>
                    <Button
                        variant={"outlined"}
                        onClick={() => handleToday('end')}
                        style={{marginLeft: 10}}
                    >
                        Today
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={handlePlusOneEndDay}
                        style={{marginLeft: 5}}
                    >
                        종료일 +1
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={handleMinusOneEndDay}
                        style={{marginLeft: 5}}
                    >
                        종료일 -1
                    </Button>
                </div>
            )}
        </div>
    );
});

export default DateStepper;